<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <v-layout row wrap align-stretch>
      <v-form v-model="valid" style="width: 100%;">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm5 md2 lg3>
            <v-text-field
              placeholder="Identificação do cliente"
              class="pr-3"
              v-model="opcoes.id_pessoa"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm5 md3 lg3>
            <v-text-field
              placeholder="CPF do Cliente"
              mask="###.###.###-##"
              class="pr-3"
              v-model="opcoes.cpf"
              :rules="[rules.cpf]"
            ></v-text-field>
          </v-flex>
           <v-flex shrink>
             <v-btn icon color="info" @click="carregarRelatorio(true)"><v-icon>search</v-icon></v-btn>
           </v-flex>
          <v-flex shrink>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="editando = !editando"
                >
                  <v-list-tile-action>
                    <v-icon v-if="!editando">edit</v-icon>
                    <v-icon v-else>done</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Editar Relatório</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="print()"
                >
                  <v-list-tile-action>
                    <v-icon>print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Imprimir Relatório</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5 hide-display">
          <v-layout row>
            <h1> Relatório de Dívidas de CashPosto</h1>
            <v-spacer></v-spacer>
            <span class="display-2">Total: {{ valor_total_divida | currency({ fractionCount: 2 }) }}</span>
          </v-layout>
          <hr/>
        </div>
        <v-data-table
          hide-actions
          :hide-headers="!carteiras || !carteiras.length"
          :loading="loading"
          :items="carteiras"
          :pagination.sync="pagination"
          :total-items="totalItens"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3" v-if="headersVisible.avatar">
                <v-icon color="success">attach_money</v-icon>
              </td>
              <td class="text-xs-left" v-if="headersVisible.pessoa">
                <template v-if="props.item.pessoa">
                  {{`${props.item.pessoa.nome_completo}` | truncate(30) }}
                  <div>ID: <strong>{{props.item.pessoa.id_pessoa}}</strong></div>
                </template>
              </td>
              <td class="text-xs-right pl-2 pr-4" v-if="headersVisible.historico">
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click="carteiraSelecionada =  props.item, dialogHistorico = true"
                  >
                    <v-icon>account_balance_wallet</v-icon>
                  </v-btn>
                  <span>Visualizar Histórico</span>
                </v-tooltip>
              </td>
              <td class="text-xs-right pl-2 pr-4" v-if="headersVisible.saldo">
                <strong>{{ props.item.saldo | currency({ fractionCount: 2 }) }}</strong>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-center px-4" v-if="headersVisible.avatar">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.avatar = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.pessoa">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.pessoa = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Cliente
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.historico">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.historico = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Histórico
              </th>
              <th class="text-xs-right pl-2 pr-4" v-if="headersVisible.saldo">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.saldo = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor (R$)
              </th>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="carteiras.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Valor total da Divida: {{ valor_total_divida | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
    <v-dialog
      v-model="dialogHistorico"
      v-if="dialogHistorico"
      width="500"
      scrollable
    >
      <historico-carteira
        :carteira="carteiraSelecionada"
        @fechar="
          dialogHistorico = false,
          carteiraSelecionada = undefined
        "
      />
    </v-dialog>
  </v-container>
</template>

<script>
import HistoricoCarteira from '@/components/dialogs/HistoricoCarteira'
export default {
  components: { HistoricoCarteira },
  data () {
    return {
      valor_total_divida: 0,
      valid: false,
      editando: false,
      dialogHistorico: false,
      carteiraSelecionada: undefined,
      headersVisible: {
        pessoa: true,
        saldo: true,
        historico: true,
        avatar: true
      },
      rules: {
        cpf: value => {
          return (value && value.length === 11) || 'CPF inválido.'
        }
      },
      opcoes: {
        id_pessoa: undefined,
        cpf: undefined
      },
      carteiras: [],
      totalItens: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    }
  },
  watch: {
    pagination: {
      handler (val) {
        if (this.posto) this.carregarRelatorio(false)
      },
      deep: true
    },
    posto (val) {
      if (val) {
        this.carregarRelatorio(true)
      }
    }
  },
  mounted () {
    if (this.posto) {
      this.carregarRelatorio(true)
    }
  },
  methods: {
    print () {
      window.print()
    },
    carregarRelatorio (zerarPaginacao) {
      const data = {
        page: zerarPaginacao ? 1 : this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        posto: this.posto.cnpj
      }

      if (this.opcoes.id_pessoa) data.pessoa__id_pessoa = this.opcoes.id_pessoa
      if (this.opcoes.cpf) data.pessoa__cpf = this.opcoes.cpf

      this.$store.dispatch('pegarCarteirasVirtuais', data).then(json => {
        this.carteiras = json.results.carteiras
        this.totalItens = json.count
        this.valor_total_divida = json.results.valor_total
      })
    }
  }
}
</script>
